export enum CommonString {
  OkButton = 'OkButton'
}
